export default "__VITE_ASSET__DfB1P7gf__"